import type TrafficChangesModel from "../TrafficChangesModel";

export const isTrafficChangesModel = (object: unknown): object is TrafficChangesModel => {
    if (typeof object !== "object" || object === null) {
        return false;
    }

    const trafficChanges = object as Partial<TrafficChangesModel>;

    const conditions = [
        typeof trafficChanges.metric === "string",
        typeof trafficChanges.period === "string",
        typeof trafficChanges.direction === "string",
        typeof trafficChanges.country === "number",
        typeof trafficChanges.value === "number",
    ];

    return conditions.every(Boolean);
};
